import React, { Fragment } from 'react'
import MainLayout from '../../layouts/MainLayout'
import SplitView from '../../layouts/SplitView/SplitView'
import PartnerDashboard from './PartnerDashboard/partner-dashboard'

const Partner = () => {
  // const routeMatch = useRouteMatch()

  return (
    <MainLayout>
      <SplitView withSideNav={false}>
        <Fragment>
          <PartnerDashboard />
        </Fragment>
      </SplitView>
    </MainLayout>
  )
}

export default Partner